import { BreakpointObserver } from '@angular/cdk/layout';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CoreConfig } from '@app/core/plugin';
import { CoreStateService, ScheduleService, SchoolService } from '@app/core/services';
import { TranslateService } from '@ngx-translate/core';
import { Observable, filter, map, switchMap } from 'rxjs';

@Component({
  selector: 'app-card-school-detail',
  templateUrl: './card-school-detail.component.html',
  styleUrls: ['./card-school-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardSchoolDetailComponent implements OnInit {
  public config$: Observable<CoreConfig>;
  public facade$: Observable<string>;
  public structure$: Observable<any>;
  public enrolment$: Observable<any>;

  constructor(
    public dialog: MatDialog,
    private scheduleService: ScheduleService,
    private translateService: TranslateService,
    private coreStateService: CoreStateService,
    private breakpointObserver: BreakpointObserver,
    private escolaService: SchoolService,
  ) {}

  public ngOnInit() {
    this.config$ = this.coreStateService.state$;
    this.structure$ = this.coreStateService.school$.pipe(
      switchMap((res) => this.escolaService.facade(res.id)),
      map(({ fachada }) => fachada),
    );

    this.facade$ = this.breakpointObserver.observe('(max-width: 576px)').pipe(
      map((state) => state.matches),
      switchMap(this.facadeLink),
    );
  }

  public onSchedule() {
    this.scheduleService.schedulingOnline();
  }

  public whatsLink(school: any): string {
    const text = this.translateService.instant('contact.whatsapp-text', { schoolName: school.nome });

    return `https://api.whatsapp.com/send?phone=${school.codigo_discagem?.replace(/\D/g, '')}${school.whatsapp}
    &text=${text}`;
  }

  public phoneLink(school: any): string {
    return `tel:${school.codigo_discagem}${school.telefone}`;
  }

  public locationMap(school: any): string {
    return `https://maps.google.com/maps?q=${school.latitude},${school.longitude}`;
  }

  private facadeLink = (isMobile: boolean): Observable<any> =>
    this.structure$.pipe(
      filter((img) => !!img),
      map((image) => (isMobile ? image.imagem_mobile : image.imagem_desktop)),
    );
}
